import { Stack } from '@mui/material';
import { DisabilityConfirmationItem } from './DisabilityApprovalItem';
import { useIsDesktop } from 'Hooks';
import { useState } from 'react';
import { PaginationResult2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { IDisabilityConfirmation } from 'API/disabilityConfirmation';
import { MedIssueReport } from './MedIssueReport';

interface IDisabilityConfirmationList {
  disabilityConfirmations: IDisabilityConfirmation[];
  isHasMedHistory: boolean;
}
export const DisabilityConfirmationsList = ({
  disabilityConfirmations,
  isHasMedHistory,
}: IDisabilityConfirmationList) => {
  const [pagination, setPagination] = useState<boolean>(false);
  const isDesktop = useIsDesktop();

  const paginationLimit = 10;

  return (
    <Stack gap={isDesktop ? '24px' : '20px'} maxWidth='850px' mt='48px'>
      {disabilityConfirmations
        ?.slice(0, pagination ? undefined : paginationLimit)
        .map((confirmation: IDisabilityConfirmation, index: number) => (
          <DisabilityConfirmationItem
            key={index}
            disabilityConfirmation={confirmation}
          />
        ))}
      {isHasMedHistory && <MedIssueReport />}
      {disabilityConfirmations.length >= 10 && !pagination && (
        <PaginationResult2
          text={Dictionary[DICTIONARY.DisabilityApprovals].moreApprovals}
          onClick={() => setPagination(true)}
        />
      )}
    </Stack>
  );
};
